import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Modal from "react-modal";
import { Row, Col } from "react-bootstrap";
import DashboardCard from "../common/DashboardCard";
import { useGetFetch } from "../../../data/Queries";
import {
  gymDashBoardReportGet,
  gymDashBoardReportGetKey,
} from "../../../data/ApiEndpoints";
import { formatNumber } from "../../../utils/utilityfunc";
import ReactVortoxSpinner from "../../../components/common-components/ReactVortoxSpinner";
import ModalHeadAndClose from "../../../components/payouts-wtf/common/ModalHeadAndClose";
import SalesCard from "../common/SalesCard";
import {
  fetchActivePtWithExpiredSubStats,
  fetchBiomaxMemberStatsData,
  fetchTotalCheckinsData,
} from "../../../redux/reducers/apiSlice";
import BiomaxRegistered from "../tables/BiomaxRegistered";
import {
  convertStraight,
  convertThenFormat,
  currentDateOfTheMonth,
  formattedAmount,
} from "../../../components/common-data/Converts";
import TabViewPTRevDetail from "../../../components/pt/tepl-cards/common/TabViewPTRevDetail";
import APESdetails from "../tables/APESdetails";
import useInterval from "../../../components/common-components/custom-hooks/useInterval";
import HeaderLine from "../../../components/lead-management/common/HeaderLine";
import CommonStatCard from "../../../components/pt/pt-flow-new/CommonStatCard";
import DotLoaders from "../../../components/common-components/loaders/DotLoaders";

const Cards = ({ user, filters, allFilters, registerApiCall, isBetaMode }) => {
  const dispatch = useDispatch();
  const {
    biomaxStats,
    biomaxStatsLoading,

    activePtExpiredSubStats,
    activePtExpiredSubStatsLoading,

    totalCheckins,
    totalCheckinsLoading,
  } = useSelector((state) => state.api);

  const isLoading =
    biomaxStatsLoading ||
    activePtExpiredSubStatsLoading ||
    totalCheckinsLoading;

  const iniModVal = {
    cardModal: false,
    clickedCard: "",
    cardName: "",
    isPreSale: false,
  };
  const [modValues, setModValues] = useState(iniModVal);
  const iniStats = {
    bioMaxStatsData: {},
    totalCheckins: {},
    ptRegSubStats: {},
  };
  const [statsData, setStatsData] = useState(iniStats);

  const onCloseModal = () => {
    setModValues(iniModVal);
  };

  const calculateSalesTrend = (salesValue) => {
    if (!salesValue || salesValue <= 0) return "down";
    return "up";
  };

  const onClickCard = (cardName, tagName) => {
    console.log("cardName=> ", cardName);

    setModValues({
      cardModal: true,
      clickedCard:
        cardName === "todays_sale" || cardName === "sales_today"
          ? "today"
          : cardName === "sales_this_month"
          ? "sales_month"
          : cardName === "personal_training"
          ? "addon_pt"
          : cardName === "active_ptexpired_subscription"
          ? "active_pt_with_expired_subscription"
          : cardName === "transaction_onlineother"
          ? "active_members"
          : cardName === "regular_sales_today" || cardName === "pt_sales_today"
          ? "today"
          : cardName,
      cardName: cardName,
      isPreSale: tagName === "pre_sales" ? true : false,
    });
  };

  const {
    data: gymDashboardData,
    isLoading: isLoadingGymDashboard,
    isFetching: isFetchingGymDashboard,
    refetch: refetchGymDashboard,
  } = useGetFetch({
    token: user?.token,
    url: gymDashBoardReportGet,
    key: gymDashBoardReportGetKey,
    filters: filters,
  });

  function isFetchingData() {
    try {
      if (isLoadingGymDashboard || isFetchingGymDashboard) {
        return true;
      }

      return false;
    } catch (error) {
      console.log(error);
    }
  }

  const triggerBiomaxStats = () => {
    if (!biomaxStatsLoading) {
      dispatch(
        fetchBiomaxMemberStatsData({
          filters: filters,
          token: user?.token,
        })
      );
    }
  };

  const triggerActivePtStats = () => {
    if (!activePtExpiredSubStatsLoading) {
      const updatedFilterAPES = { ...filters, type: "card" };

      dispatch(
        fetchActivePtWithExpiredSubStats({
          filters: updatedFilterAPES,
          token: user?.token,
        })
      );
    }
  };

  const triggerTotalCheckins = () => {
    if (!totalCheckinsLoading) {
      const updatedFilters = {
        ...filters,
        date_from: convertStraight(currentDateOfTheMonth),
        date_to: convertStraight(currentDateOfTheMonth),
      };

      dispatch(
        fetchTotalCheckinsData({
          filters: updatedFilters,
          token: user?.token,
        })
      );
    }
  };

  const fetchAllAPIs = () => {
    try {
      if (!isFetchingData()) {
        refetchGymDashboard();
        triggerBiomaxStats();
        triggerActivePtStats();
        triggerTotalCheckins();
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    try {
      refetchGymDashboard();
    } catch (error) {
      console.log(error);
    }
  }, [filters.gym_id]);

  useInterval(fetchAllAPIs, 300000);

  useEffect(() => {
    triggerBiomaxStats();
    triggerActivePtStats();
    triggerTotalCheckins();
  }, [filters, user]);

  useEffect(() => {
    if (registerApiCall) {
      registerApiCall(refetchGymDashboard);
      registerApiCall(triggerBiomaxStats);
      registerApiCall(triggerActivePtStats);
      registerApiCall(triggerTotalCheckins);
    }
  }, [registerApiCall]);

  useEffect(() => {
    if (biomaxStats?.status && biomaxStats?.data) {
      setStatsData((prevs) => ({
        ...prevs,
        bioMaxStatsData: biomaxStats.data,
      }));
    } else {
      setStatsData((prevs) => ({
        ...prevs,
        bioMaxStatsData: {},
      }));
    }
  }, [biomaxStats]);

  useEffect(() => {
    if (totalCheckins?.status && totalCheckins?.data) {
      setStatsData((prevs) => ({
        ...prevs,
        totalCheckins: totalCheckins.data,
      }));
    } else {
      setStatsData((prevs) => ({
        ...prevs,
        totalCheckins: {},
      }));
    }
  }, [totalCheckins]);

  useEffect(() => {
    if (activePtExpiredSubStats?.status && activePtExpiredSubStats?.data) {
      setStatsData((prevs) => ({
        ...prevs,
        ptRegSubStats: activePtExpiredSubStats.data,
      }));
    } else {
      setStatsData((prevs) => ({
        ...prevs,
        ptRegSubStats: {},
      }));
    }
  }, [activePtExpiredSubStats]);

  // console.log("gymDashboardData=> ", gymDashboardData);

  return (
    <>
      <Modal
        isOpen={modValues.cardModal}
        onRequestClose={onCloseModal}
        contentLabel="Details Modal"
        ariaHideApp={false}
      >
        {modValues.clickedCard === "addon_pt" ? (
          <TabViewPTRevDetail
            prevGymId={filters.gym_id}
            onCloseModal={onCloseModal}
          />
        ) : (
          <div
            className={`createNewCTOModalContainer home-card-container-modal`}
          >
            <ModalHeadAndClose
              title={`${
                modValues.clickedCard === "active_members" ||
                modValues.clickedCard === "unpaid_members" ||
                modValues.clickedCard === "checkins" ||
                modValues.clickedCard === "biomax_registered_members"
                  ? ""
                  : modValues.clickedCard === "addon_pt"
                  ? "Personal Training"
                  : modValues.clickedCard?.replace(/_/g, " ")
              }`}
              onClose={onCloseModal}
            />

            {modValues.clickedCard === "today" ||
            modValues.clickedCard === "sales_month" ||
            modValues.clickedCard === "regular" ||
            modValues.clickedCard === "addon" ||
            modValues.clickedCard === "active_members" ||
            modValues.clickedCard === "checkins" ||
            modValues.clickedCard === "unpaid_members" ||
            modValues.clickedCard === "expiring_today" ||
            modValues.clickedCard === "expiring_this_month" ? (
              <SalesCard
                user={user}
                clickedCard={modValues.clickedCard}
                filters={filters}
                prevSelGym={allFilters.selectedGym}
                prevPrevAllFilters={allFilters}
                cardName={modValues.cardName}
                isPreSale={modValues.isPreSale}
              />
            ) : modValues.clickedCard === "biomax_registered_members" ? (
              <BiomaxRegistered user={user} filters={allFilters} />
            ) : modValues.clickedCard ===
              "active_pt_with_expired_subscription" ? (
              <APESdetails user={user} filters={filters} />
            ) : null}
          </div>
        )}
      </Modal>

      <Row>
        <Col>
          {isBetaMode ? (
            <div className="home-sales-cards-container mt30">
              {/* <div className="home-sales-card-box">
              <p className="home-sales-card-box-title">All Gym Sales</p>

              <div className="cards-container cards-grid-container grid-3">
                <CommonStatCard
                  tagName="home"
                  cardLabel="Sales Today"
                  value={
                    isFetchingData() ? (
                      <DotLoaders color="#000" />
                    ) : (
                      `₹${formatNumber(gymDashboardData?.data?.todaySale)}`
                    )
                  }
                  onClickCard={() => onClickCard("sales_today", "sales")}
                />

                <CommonStatCard
                  tagName="home"
                  cardLabel="Regular Sales Today"
                  value={
                    isFetchingData() ? (
                      <DotLoaders color="#000" />
                    ) : (
                      `₹${formatNumber(
                        gymDashboardData?.data?.totalSalesRegular
                      )}`
                    )
                  }
                  onClickCard={() =>
                    onClickCard("regular_sales_today", "plans")
                  }
                />

                <CommonStatCard
                  tagName="home"
                  cardLabel="PT Sales Today"
                  value={
                    isFetchingData() ? (
                      <DotLoaders color="#000" />
                    ) : (
                      `₹${formatNumber(
                        gymDashboardData?.data?.totalSalesAddonPT
                      )}`
                    )
                  }
                  onClickCard={() => onClickCard("pt_sales_today", "plans")}
                />
              </div>
            </div> */}

              <div className="home-sales-card-box">
                <p className="home-sales-card-box-title">Regular Gym Sales</p>

                <div className="cards-container cards-grid-container grid-3">
                  <CommonStatCard
                    tagName="home"
                    cardLabel="Sales Today"
                    value={
                      isFetchingData() ? (
                        <DotLoaders color="#000" />
                      ) : (
                        `₹${formatNumber(
                          gymDashboardData?.data?.regularGymSalesToday
                        )}`
                      )
                    }
                    trend={calculateSalesTrend(
                      gymDashboardData?.data?.regularGymSalesToday
                    )}
                    onClickCard={() => onClickCard("sales_today", "sales")}
                  />

                  <CommonStatCard
                    tagName="home"
                    cardLabel="Regular Sales Today"
                    value={
                      isFetchingData() ? (
                        <DotLoaders color="#000" />
                      ) : (
                        `₹${formatNumber(
                          gymDashboardData?.data?.regularSubsNonPresaleToday ||
                            0
                        )}`
                      )
                    }
                    trend={calculateSalesTrend(
                      gymDashboardData?.data?.regularSubsNonPresaleToday
                    )}
                    onClickCard={() =>
                      onClickCard("regular_sales_today", "plans")
                    }
                  />

                  <CommonStatCard
                    tagName="home"
                    cardLabel="PT Sales Today"
                    value={
                      isFetchingData() ? (
                        <DotLoaders color="#000" />
                      ) : (
                        `₹${formatNumber(
                          gymDashboardData?.data?.ptSubsNonPresaleToday
                        )}`
                      )
                    }
                    trend={calculateSalesTrend(
                      gymDashboardData?.data?.ptSubsNonPresaleToday
                    )}
                    onClickCard={() => onClickCard("pt_sales_today", "plans")}
                  />
                </div>
              </div>

              <div className="home-sales-card-box">
                <p className="home-sales-card-box-title">Gym Pre Sales</p>

                <div className="cards-container cards-grid-container grid-3">
                  <CommonStatCard
                    tagName="home"
                    cardLabel="Sales Today"
                    value={
                      isFetchingData() ? (
                        <DotLoaders color="#000" />
                      ) : (
                        `₹${formatNumber(
                          gymDashboardData?.data?.preSaleGymSalesToday
                        )}`
                      )
                    }
                    trend={calculateSalesTrend(
                      gymDashboardData?.data?.preSaleGymSalesToday
                    )}
                    onClickCard={() => onClickCard("sales_today", "pre_sales")}
                  />

                  <CommonStatCard
                    tagName="home"
                    cardLabel="Regular Sales Today"
                    value={
                      isFetchingData() ? (
                        <DotLoaders color="#000" />
                      ) : (
                        `₹${formatNumber(
                          gymDashboardData?.data?.regularSubsPresaleToday || 0
                        )}`
                      )
                    }
                    trend={calculateSalesTrend(
                      gymDashboardData?.data?.regularSubsPresaleToday
                    )}
                    onClickCard={() =>
                      onClickCard("regular_sales_today", "pre_sales")
                    }
                  />

                  <CommonStatCard
                    tagName="home"
                    cardLabel="PT Sales Today"
                    value={
                      isFetchingData() ? (
                        <DotLoaders color="#000" />
                      ) : (
                        `₹${formatNumber(
                          gymDashboardData?.data?.ptSubsPresaleToday
                        )}`
                      )
                    }
                    trend={calculateSalesTrend(
                      gymDashboardData?.data?.ptSubsPresaleToday
                    )}
                    onClickCard={() =>
                      onClickCard("pt_sales_today", "pre_sales")
                    }
                  />
                </div>
              </div>
            </div>
          ) : (
            <>
              {isFetchingData() ? (
                <ReactVortoxSpinner />
              ) : (
                <>
                  <HeaderLine text="All Gym Sales" isMB={true} />
                  <div className="cards-container cards-grid-container grid-4 mt-2rem mb30">
                    <DashboardCard
                      tagName={"sales"}
                      cardLabel={"Today's Sale"}
                      value={`₹${formatNumber(
                        gymDashboardData?.data?.todaySale
                      )}`}
                      onClickCard={onClickCard}
                    />

                    <DashboardCard
                      tagName={"plans"}
                      cardLabel={"Regular"}
                      value={`₹${formatNumber(
                        gymDashboardData?.data?.totalSalesRegular
                      )}`}
                      onClickCard={onClickCard}
                    />

                    <DashboardCard
                      tagName={"plans"}
                      cardLabel={"Personal Training"}
                      value={`₹${formatNumber(
                        gymDashboardData?.data?.totalSalesAddonPT
                      )}`}
                      onClickCard={onClickCard}
                    />
                  </div>

                  <HeaderLine text="Regular Gym Sales" isMB={true} />
                  <div className="cards-container cards-grid-container grid-4 mt-2rem mb30">
                    <DashboardCard
                      tagName={"sales"}
                      cardLabel={"Sales Today"}
                      value={`₹${formatNumber(
                        gymDashboardData?.data?.regularGymSalesToday
                      )}`}
                      onClickCard={onClickCard}
                    />

                    <DashboardCard
                      tagName={"plans"}
                      cardLabel={"Regular Sales Today"}
                      value={`₹${formatNumber(
                        gymDashboardData?.data?.regularSubsNonPresaleToday || 0
                      )}`}
                      onClickCard={onClickCard}
                    />

                    <DashboardCard
                      tagName={"plans"}
                      cardLabel={"PT Sales Today"}
                      value={`₹${formatNumber(
                        gymDashboardData?.data?.ptSubsNonPresaleToday
                      )}`}
                      onClickCard={onClickCard}
                    />
                  </div>

                  <HeaderLine text="Gym Pre Sales" isMB={true} />
                  <div className="cards-container cards-grid-container pre-sales-grid grid-4 mt-2rem mb30">
                    <DashboardCard
                      tagName={"pre_sales"}
                      cardLabel={"Sales Today"}
                      value={`₹${formatNumber(
                        gymDashboardData?.data?.preSaleGymSalesToday || 0
                      )}`}
                      onClickCard={onClickCard}
                    />

                    <DashboardCard
                      tagName={"pre_sales"}
                      cardLabel={"Regular Sales Today"}
                      value={`₹${formatNumber(
                        gymDashboardData?.data?.regularSubsPresaleToday || 0
                      )}`}
                      onClickCard={onClickCard}
                    />

                    <DashboardCard
                      tagName={"pre_sales"}
                      cardLabel={"PT Sales Today"}
                      value={`₹${formatNumber(
                        gymDashboardData?.data?.ptSubsPresaleToday
                      )}`}
                      onClickCard={onClickCard}
                    />
                  </div>
                </>
              )}
            </>
          )}
        </Col>
      </Row>

      <Row>
        <Col>
          {isBetaMode ? (
            <div className="home-sales-cards-container grid-3 mt30">
              <div className="home-sales-card-box span2">
                <p className="home-sales-card-box-title">Memberships</p>

                <div className="home-sales-card-box-divider">
                  <div className="cards-container cards-grid-container grid-4">
                    <CommonStatCard
                      tagName="home"
                      cardLabel="Unpaid Members"
                      value={
                        isFetchingData() ? (
                          <DotLoaders color="#000" />
                        ) : gymDashboardData?.data?.unpaidMembers ? (
                          formatNumber(gymDashboardData.data.unpaidMembers)
                        ) : (
                          0
                        )
                      }
                      onClickCard={() => onClickCard("unpaid_members")}
                    />

                    <CommonStatCard
                      tagName="home"
                      cardLabel="Expiring today"
                      value={
                        isFetchingData() ? (
                          <DotLoaders color="#000" />
                        ) : gymDashboardData?.data?.expiringToday ? (
                          formatNumber(gymDashboardData.data.expiringToday)
                        ) : (
                          0
                        )
                      }
                      onClickCard={() => onClickCard("expiring_today")}
                    />

                    <CommonStatCard
                      tagName="home"
                      cardLabel="Expiring this month"
                      value={
                        isFetchingData() ? (
                          <DotLoaders color="#000" />
                        ) : gymDashboardData?.data?.expiringThisMonth ? (
                          formatNumber(gymDashboardData.data.expiringThisMonth)
                        ) : (
                          0
                        )
                      }
                      onClickCard={() => onClickCard("expiring_this_month")}
                    />

                    <CommonStatCard
                      tagName="home"
                      cardLabel="Renewals/New Subsciption"
                      value={
                        isFetchingData() ? (
                          <DotLoaders color="#000" />
                        ) : gymDashboardData?.data ? (
                          `${formatNumber(
                            gymDashboardData?.data?.renewals
                              ? gymDashboardData.data.renewals
                              : 0
                          )}/${formatNumber(
                            gymDashboardData?.data?.newsubs
                              ? gymDashboardData.data.newsubs
                              : 0
                          )}`
                        ) : (
                          0
                        )
                      }
                    />
                  </div>

                  <div className="grayLine"></div>

                  <div className="cards-container cards-grid-container grid-3">
                    <CommonStatCard
                      tagName="home"
                      cardLabel="Biomax Registered Members"
                      value={
                        isFetchingData() ? (
                          <DotLoaders color="#000" />
                        ) : (
                          `${formattedAmount(
                            parseInt(
                              statsData.bioMaxStatsData
                                ?.total_biomax_registered || 0
                            )
                          )}/${formattedAmount(
                            parseInt(
                              statsData.bioMaxStatsData?.total_subscription || 0
                            )
                          )}`
                        )
                      }
                      onClickCard={() =>
                        onClickCard("biomax_registered_members")
                      }
                    />

                    <CommonStatCard
                      tagName="home"
                      cardLabel="Active PT/Expired Subscription"
                      value={
                        isFetchingData() ? (
                          <DotLoaders color="#000" />
                        ) : (
                          `${convertThenFormat(
                            statsData.ptRegSubStats?.total_pt_active || 0
                          )}/${convertThenFormat(
                            statsData.ptRegSubStats?.total_reg_expired || 0
                          )}`
                        )
                      }
                      onClickCard={() =>
                        onClickCard("active_ptexpired_subscription")
                      }
                    />

                    <CommonStatCard
                      tagName="home"
                      cardLabel="Transaction: Online/Other"
                      value={
                        isFetchingData() ? (
                          <DotLoaders color="#000" />
                        ) : (
                          `${parseInt(
                            gymDashboardData?.data?.salesOnline
                              ? gymDashboardData.data.salesOnline
                              : 0
                          )}/${formattedAmount(
                            parseInt(
                              gymDashboardData?.data?.salesOthers
                                ? gymDashboardData.data.salesOthers
                                : 0
                            )
                          )}`
                        )
                      }
                    />
                  </div>
                </div>
              </div>

              <div className="home-sales-card-box">
                <p className="home-sales-card-box-title">Checkins</p>

                <div className="home-sales-card-box-divider">
                  <div className="cards-container cards-grid-container grid-1">
                    <CommonStatCard
                      tagName="home"
                      cardLabel="Today's Checkins"
                      value={
                        isFetchingData() ? (
                          <DotLoaders color="#000" />
                        ) : statsData.totalCheckins?.all?.total ? (
                          statsData.totalCheckins.all.total
                        ) : (
                          0
                        )
                      }
                      onClickCard={() => onClickCard("checkins")}
                    />
                  </div>

                  <div className="grayLine"></div>

                  <div className="home-sales-card-box-tags">
                    <span className="label member">
                      Members: {statsData.totalCheckins?.member?.total || 0}
                    </span>

                    <span className="label trainer">
                      Trainer: {statsData.totalCheckins?.trainer?.total || 0}
                    </span>

                    <span className="label staff">
                      Staff: {statsData.totalCheckins?.staff?.total || 0}
                    </span>

                    <span className="label guest">
                      Guest: {statsData.totalCheckins?.guest?.total || 0}
                    </span>

                    <span className="label housekeeping">
                      housekeeping:{" "}
                      {statsData.totalCheckins?.housekeeping?.total || 0}
                    </span>

                    <span className="label gyms">
                      gym owner: {statsData.totalCheckins?.gyms?.total || 0}
                    </span>

                    <span className="label admin">
                      Admin: {statsData.totalCheckins?.admin?.total || 0}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <>
              {isFetchingData() ? (
                <ReactVortoxSpinner />
              ) : (
                <>
                  <div className="cards-container cards-grid-container grid-4 mt-2rem">
                    <DashboardCard
                      tagName={"subscription"}
                      cardLabel={"Renewals/New Subsciption"}
                      value={
                        gymDashboardData?.data
                          ? `${formatNumber(
                              gymDashboardData?.data?.renewals
                                ? gymDashboardData.data.renewals
                                : 0
                            )}/${formatNumber(
                              gymDashboardData?.data?.newsubs
                                ? gymDashboardData.data.newsubs
                                : 0
                            )}`
                          : 0
                      }
                      onClickCard={onClickCard}
                    />

                    <DashboardCard
                      tagName={"members"}
                      cardLabel={"Expiring today"}
                      value={
                        gymDashboardData?.data?.expiringToday
                          ? formatNumber(gymDashboardData.data.expiringToday)
                          : 0
                      }
                      onClickCard={onClickCard}
                    />

                    <DashboardCard
                      tagName={"members"}
                      cardLabel={"Expiring this month"}
                      value={
                        gymDashboardData?.data?.expiringThisMonth
                          ? formatNumber(
                              gymDashboardData.data.expiringThisMonth
                            )
                          : 0
                      }
                      onClickCard={onClickCard}
                    />

                    <DashboardCard
                      tagName={"active_pt_expired_sub"}
                      cardLabel={"Active PT/Expired Subscription"}
                      value={`${convertThenFormat(
                        statsData.ptRegSubStats?.total_pt_active || 0
                      )}/${convertThenFormat(
                        statsData.ptRegSubStats?.total_reg_expired || 0
                      )}`}
                      onClickCard={onClickCard}
                    />

                    <DashboardCard
                      tagName={"transactions"}
                      cardLabel={"Transaction: Online/Other"}
                      value={`${parseInt(
                        gymDashboardData?.data?.salesOnline
                          ? gymDashboardData.data.salesOnline
                          : 0
                      )}/${formattedAmount(
                        parseInt(
                          gymDashboardData?.data?.salesOthers
                            ? gymDashboardData.data.salesOthers
                            : 0
                        )
                      )}`}
                      onClickCard={onClickCard}
                    />

                    {isLoading ? (
                      <ReactVortoxSpinner />
                    ) : (
                      <DashboardCard
                        tagName={"members"}
                        cardLabel={"Biomax Registered Members"}
                        value={`${formattedAmount(
                          parseInt(
                            statsData.bioMaxStatsData
                              ?.total_biomax_registered || 0
                          )
                        )}/${formattedAmount(
                          parseInt(
                            statsData.bioMaxStatsData?.total_subscription || 0
                          )
                        )}`}
                        onClickCard={onClickCard}
                      />
                    )}

                    <DashboardCard
                      tagName={"members"}
                      cardLabel={"Active members"}
                      value={
                        gymDashboardData?.data?.activeMembers
                          ? formatNumber(gymDashboardData.data.activeMembers)
                          : 0
                      }
                      onClickCard={onClickCard}
                    />

                    <DashboardCard
                      tagName={"members"}
                      cardLabel={"Unpaid Members"}
                      value={
                        gymDashboardData?.data?.unpaidMembers
                          ? formatNumber(gymDashboardData.data.unpaidMembers)
                          : 0
                      }
                      onClickCard={onClickCard}
                    />
                  </div>

                  <div className="cards-container cards-grid-container grid-3 mt-2rem">
                    <DashboardCard
                      tagName={"members"}
                      cardLabel={"Checkins"}
                      value={
                        statsData.totalCheckins?.all?.total
                          ? statsData.totalCheckins.all.total
                          : 0
                      }
                      checkinTypes={statsData.totalCheckins}
                      onClickCard={onClickCard}
                    />
                  </div>
                </>
              )}
            </>
          )}
        </Col>
      </Row>
    </>
  );
};

export default Cards;
